module.exports = __webpack_public_path__ + "img/siman-kriya-red.c36f1745.svg";